import type { TierBadge } from '../../../../modules/api';
import { TierCard } from './TierCard';

export interface TierSelectorProps {
  badges: TierBadge[];
  onSelect?: (poolOfferId: number) => void;
}

/**
 * Horizontal row of TierCards with hidden scrollbar and a right-edge fade
 * when content overflows. No padding of its own — the parent
 * `PackInfoCard` controls outer spacing so edges align with the card
 * border. Reuses `scrollbar-hide` + `fade-edge-r` from `index.css`.
 */
export function TierSelector({ badges, onSelect }: TierSelectorProps) {
  if (badges.length === 0) return null;
  return (
    <div
      className="
        scrollbar-hide fade-edge-r
        flex items-center gap-2 overflow-x-auto
      "
    >
      {badges.map((b) => (
        <TierCard
          key={b.poolOfferId}
          badge={b}
          onClick={() => onSelect?.(b.poolOfferId)}
        />
      ))}
    </div>
  );
}
